import {
  ZOOM_OVERLAY_COMBOBOX_Z_INDEX,
  ZOOM_OVERLAY_MODAL_COMBOBOX_Z_INDEX,
  ZOOM_OVERLAY_MODAL_Z_INDEX,
} from './sessionAttendance';

const ZOOM_COMBOBOX_PORTAL_ID = 'unify-zoom-combobox-portal';
const ZOOM_MODAL_PORTAL_ID = 'unify-zoom-modal-portal';

function portalTarget(id: string): HTMLElement | null {
  return typeof document !== 'undefined' ? document.getElementById(id) : null;
}

function zoomSidebarPortalTarget(): HTMLElement | null {
  return portalTarget(ZOOM_COMBOBOX_PORTAL_ID);
}

/**
 * Props for a Mantine Modal shown over a live Zoom call. The sidebar combobox
 * portal is clipped to the panel, so full-width dialogs get their own
 * viewport-sized container.
 */
export function zoomOverlayModalProps() {
  const target = portalTarget(ZOOM_MODAL_PORTAL_ID);

  return {
    modalZIndex: ZOOM_OVERLAY_MODAL_Z_INDEX,
    modalPortalTarget: target,
    comboboxProps: {
      withinPortal: true,
      ...(target ? { portalProps: { target } } : {}),
      zIndex: ZOOM_OVERLAY_MODAL_COMBOBOX_Z_INDEX,
      styles: { dropdown: { pointerEvents: 'auto' as const } },
    },
    popoverProps: {
      withinPortal: true,
      ...(target ? { portalProps: { target } } : {}),
      zIndex: ZOOM_OVERLAY_MODAL_COMBOBOX_Z_INDEX,
    },
  };
}

/** Mantine combobox props so Select dropdowns work above the Zoom Web SDK overlay. */
export function zoomSidebarComboboxProps() {
  const target = zoomSidebarPortalTarget();

  return {
    withinPortal: true,
    ...(target ? { portalProps: { target } } : {}),
    zIndex: ZOOM_OVERLAY_COMBOBOX_Z_INDEX,
    styles: {
      dropdown: {
        pointerEvents: 'auto' as const,
      },
    },
  };
}

/** Mantine popover props so DatePickerInput calendars work above the Zoom overlay. */
export function zoomSidebarPopoverProps() {
  const target = zoomSidebarPortalTarget();

  return {
    withinPortal: true,
    ...(target ? { portalProps: { target } } : {}),
    zIndex: ZOOM_OVERLAY_COMBOBOX_Z_INDEX,
  };
}
